import RandingStyle9 from "../../randing/RandingStyle9";

function Randing053({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/053/25010301.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/053/25010302.jpg`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/consultInquiryButton.png`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/053/25010303.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/053/25010304.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/053/25010305.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/053/25010306.jpg`}
      callNumber={"tel:1533-1428"}
      privacyMessage="개인정보수집에 동의하시는 분만 '상담문의' 버튼을 눌러주세요."
      eventDates={true}
      companyName="광교365리움치과병원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/gwanggyo.jpg`}
      carrotTag={true}
    />
  );
}

export default Randing053;
